import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Upload } from './Upload';
import ModalHeader from 'react-bootstrap/esm/ModalHeader';
import Examples from './Examples';
import '../styles/components/info-modal.scss';

const InfoModal = ({ show, handleClose, handleOnSubmit, title, description, upload }) => {
  const [fileUploaded, setFileUploaded] = useState(false);
  const [uploadError, setUploadError] = useState(false);

  const handleOnDrop = async (file) => {
    setFileUploaded(true);
    handleOnSubmit(file);
  };

  return (
    <Modal
      size="lg"
      show={show}
      onHide={() => {
        setFileUploaded(false);
        handleClose();
      }}
      backdrop="static"
      scrollable={true}
    >
      <ModalHeader closeButton className="border-bottom-0 px-4">
        {<h2 className="fs-1 px-4">{title}</h2>}
      </ModalHeader>
      <Modal.Body className="d-flex flex-column">
        <div className="mb-4">
          {!fileUploaded && <>{Examples[title] && !upload ? Examples[title] : description}</>}
          {fileUploaded && uploadError && (
            <>
              <h4>File failed to upload correctly.</h4>
            </>
          )}
          {fileUploaded && !uploadError && (
            <>
              Your file was successfully uploaded. You will be emailed when your upload is complete.
              <p>
                (This can take up to <strong>1 hour</strong>)
              </p>
              <i>If you have not received an email after 1 hour, please contact support.</i>
            </>
          )}
          {!fileUploaded && (
            <div className="mt-4">
              {upload && <Upload onDrop={(file) => handleOnDrop(file)} setError={setUploadError} />}
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          data-cy="close-button"
          className="dark-btn btn btn-primary"
          onClick={() => {
            setFileUploaded(false);
            handleClose();
          }}
        >
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default InfoModal;
